// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_value_data(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "Agent",
              "RegisteredClient"
            ]);
}

var fragmentConverter = {"__root":{"value_data_RegisteredClient_emailAddress":{"b":""},"value_data_Agent_emailAddress":{"b":""},"value_data":{"u":"fragment_value_data"}}};

var fragmentConverterMap = {
  fragment_value_data: unwrap_fragment_value_data
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProfilePhoto",
    "kind": "LinkedField",
    "name": "profilePhoto",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true,
    "catchTo": "RESULT"
  },
  "name": "UserSessionUserDisplayInfo_userDisplayInfo",
  "selections": [
    (v0/*: any*/),
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "RegisteredClient",
            "abstractKey": null
          }
        ],
        "type": null,
        "abstractKey": null
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "data"
    }
  ],
  "type": "AuthenticatedUserV6",
  "abstractKey": "__isAuthenticatedUserV6"
};
})());

var wrap_fragment_value_data = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_value_data = unwrap_fragment_value_data;
exports.wrap_fragment_value_data = wrap_fragment_value_data;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
